import ClubEmployee from './ClubEmployee';
import Department from './Department';
import {format} from '@legacy/js/date/date-fns.js';

export default class ClubEmployeeDepartmentRelation {

    static fromData(data) {
        if (!data) {
            return;
        }

        let employeeRelation = new ClubEmployeeDepartmentRelation();
        employeeRelation.id = data.id;
        employeeRelation.department = Department.fromData(data.department);
        employeeRelation.employee = ClubEmployee.fromData(data.employee);
        employeeRelation.start = new Date(data.start);
        employeeRelation.end = data.end !== null ? new Date(data.end) : null;
        employeeRelation.invalid = false;
        employeeRelation.isEditable = data.isEditable;
        employeeRelation.isDeletable = data.isDeletable;

        Object.seal(employeeRelation);
        return employeeRelation;
    }

    toData() {
        let start = new Date(this.start);
        let end = this.end === null ? null : new Date(this.end);

        return {
            id: this.id,
            department: this.department,
            start: format(start, 'dd.MM.yyyy'),
            end: end === null ? null : format(end, 'dd.MM.yyyy'),
            employeeId: this.employee.id,
            employee: this.employee,
            invalid: this.invalid,
        };
    }

    isEmptyDepartment() {
        return !this.department;
    }

    isEmptyEmployee() {
        return !this.employee;
    }

    isValidDepartment() {
        if (!this.department) {
            return false;
        }

        return this.hasValidDates();
    }

    isValidEmployee() {
        if (!this.employee) {
            return false;
        }

        return this.hasValidDates();
    }
    hasValidDates() {
        if (!this.start) {
            return false;
        }
        if (this.end && this.start > this.end) {
            return false;
        }

        return true;
    }

    formattedStart() {
        return format(this.start, 'dd.MM.yyyy');
    }

    formattedEnd() {
        return this.end === null ? null : format(this.end, 'dd.MM.yyyy');
    }
}
